import { fetchAuthSession, fetchUserAttributes } from 'aws-amplify/auth';

export async function checkAdminStatus() {
  try {
    const session = await fetchAuthSession();
    console.log('Auth session:', session); // Log the entire session

    if (!session || !session.tokens || !session.tokens.accessToken) {
      console.log('No valid session or access token found');
      return false;
    }

    const { payload } = session.tokens.accessToken;
    console.log('Access token payload:', payload);

    // Check if 'cognito:groups' exists in the payload and if it includes 'admin'
    const groups = payload['cognito:groups'] || [];
    const isAdmin = groups.includes('admin');
    
    console.log('User groups:', groups);
    console.log('Is admin:', isAdmin);
    
    return isAdmin;
  } catch (error) {
    console.error('Error checking admin status:', error);
    return false;
  }
}

export const checkCreatorStatus = async () => {
  try {
    const session = await fetchAuthSession();
    const groups = session.tokens.accessToken.payload['cognito:groups'] || [];
    return groups.includes('creator') || groups.includes('admin');
  } catch (error) {
    console.error('Error checking creator status:', error);
    return false;
  }
};